import { FormHelperText, Typography } from "@mui/material";
import AceEditor from "react-ace";
import { useInput } from "react-admin";

import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/keybinding-vscode";
import "ace-builds/src-min-noconflict/mode-html";
import "ace-builds/src-min-noconflict/mode-json";
import "ace-builds/src-min-noconflict/mode-sql";
import "ace-builds/src-min-noconflict/theme-monokai";

export const bulkEmailResources = {
  campaigns: "bulk-email-campaigns",
  segments: "bulk-email-segments",
  templates: "bulk-email-templates",
  suppressions: "bulk-email-suppressions",
  runs: "bulk-email-runs",
};

export function AceInput({
  source,
  label,
  mode,
  height = "55vh",
  defaultValue = "",
  validate,
}) {
  const { field, fieldState } = useInput({ source, defaultValue, validate });

  return (
    <div style={{ width: "100%" }}>
      <Typography variant="caption">{label}</Typography>
      <AceEditor
        width="100%"
        height={height}
        mode={mode}
        theme="monokai"
        value={field.value || ""}
        onChange={field.onChange}
        onBlur={field.onBlur}
        setOptions={{ useWorker: false, wrap: true }}
      />
      {fieldState.error && (
        <FormHelperText error>{fieldState.error.message}</FormHelperText>
      )}
    </div>
  );
}

export function validJson(value) {
  try {
    JSON.parse(value || "{}");
    return undefined;
  } catch (_error) {
    return "Must be valid JSON";
  }
}

export function parseJson(value) {
  return JSON.parse(value || "{}");
}
